export function safeJsonParse (json, defaultValue = null) {
	try {
		return JSON.parse(json)
	} catch (e) {
		return defaultValue
	}
}

export function safeJsonArrayParse (attr) {
	if (attr == null) return null
	const values = safeJsonParse(attr)
	if (values == null || !Array.isArray(values)) return null
	return values
}
